import { render, staticRenderFns } from "./menuSection.vue?vue&type=template&id=d7a9a07a&"
import script from "./menuSection.vue?vue&type=script&lang=js&"
export * from "./menuSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports